import { Injectable } from '@angular/core';

import { ApiService } from '../../../../../common/services/api.service';
import { environment } from 'src/environments/environment';
import { apiEndPoints } from '../../../../../common/constants/api-endpointsconstant';
import { ReportService } from 'src/app/reports/services/report.service';
import { LoaderType } from 'src/app/common/models/enums/common.enum';

@Injectable({
  providedIn: 'root'
})
export class ReportUnitService {

  constructor(
    private apiServive: ApiService,
    private reportService: ReportService
  ) { }

  getTotalUnit(year = null){
   
    const url: string = `${environment.miUrl}${apiEndPoints.totalInventoryReport}${this.reportService.filterQueryParams}`;
    return this.apiServive.get(url);
  }

  getInvestmentUnitReport(){
    const url: string = `${environment.miUrl}${apiEndPoints.investmentUnitReport}${this.reportService.filterQueryParams}`;
    return this.apiServive.get(url);
  }

  getUnitOccupancyTypeReport(type: string, year = null){
    let queryParams = {...this.reportService.queryParams};
    if(queryParams?.year){
      queryParams.year = year ? year : this.reportService.yearMaxValue(queryParams.year);
    }
    const changeParams = this.reportService.setfilterQueryParams(queryParams);
    const url: string = `${environment.miUrl}${apiEndPoints.unitOccupancyTypeReport}${changeParams}&type=${type}`;
    return this.apiServive.get(url);
  }

  getUnitOccupancyAverageReport(){
    const url: string = `${environment.miUrl}${apiEndPoints.unitOccupancyLeaseReport}${this.reportService.filterQueryParams}`;
    return this.apiServive.get(url);
  }

  getUnitTypeReport(){
    let url: string = `${environment.miUrl}${apiEndPoints.unitTypeReport}${this.reportService.filterQueryParams}`;
    return this.apiServive.get(url);
  }

}
